export const USER_FEEDBACK_TYPE = {
  GENERAL_FEEDBACK_MODAL: 'GENERAL_FEEDBACK_MODAL',
  INACCURACIES_MODAL: 'INACCURACIES_MODAL',
};
